module.exports = flarum.core.compat['components/SettingDropdown'];